import { MAIN_CONTENT_SCROLL_TOP_OFFSET } from '@/shared/docs-shared.const'
import { getMainContentScrollContainer } from '@/shared/utils/getMainContentScrollContainer'

export function scrollMainContentToElement(element: HTMLElement) {
  const scrollContainer = getMainContentScrollContainer()
  if (!scrollContainer) {
    return
  }

  const containerRect = scrollContainer.getBoundingClientRect()
  const elementRect = element.getBoundingClientRect()
  const offset = elementRect.top - containerRect.top + scrollContainer.scrollTop - MAIN_CONTENT_SCROLL_TOP_OFFSET

  scrollContainer.scrollTo({ top: Math.max(offset, 0), behavior: 'auto' })
}
